import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';
import { Icon } from '@ontruck/orc';
import { IS_TENANT } from 'tenant/config';

const enhance = compose(injectIntl);

const HeightCell = React.memo(({ item_height, showIcon, intl, color = 'grey500' }) => {
  if (IS_TENANT) return <></>;
  const units = intl.messages.units;
  return item_height ? (
    <span>
      {!!showIcon && <Icon glyph="height" size="1.6rem" color={color} />}
      <span>
        {item_height / 100} {units.m}
      </span>
    </span>
  ) : null;
});

HeightCell.propTypes = {
  item_height: PropTypes.number.isRequired,
  intl: PropTypes.object.isRequired,
  showIcon: PropTypes.bool,
};

HeightCell.defaultProps = {
  showIcon: true,
};

export default enhance(HeightCell);
